import {isWeb} from 'utils/platform';

export function getCookie(name: string): string | undefined {
  if (!isWeb()) return undefined;
  try {
    const prefix = `${encodeURIComponent(name)}=`;
    for (const part of document.cookie.split('; ')) {
      if (part.startsWith(prefix))
        return decodeURIComponent(part.slice(prefix.length));
    }
  } catch {}
  return undefined;
}

export function setCookie(name: string, value: string): void {
  if (!isWeb()) return;
  try {
    const secure = location.protocol === 'https:' ? '; Secure' : '';
    document.cookie =
      `${encodeURIComponent(name)}=${encodeURIComponent(value)}`
      + `; Path=/; SameSite=Lax${secure}`;
  } catch {}
}
